// extracted by mini-css-extract-plugin
export default {"CrossLinks":"CrossLinks_CrossLinks__MTM5N","CrossLinks__header":"CrossLinks_CrossLinks__header__ZDVjN","CrossLinks__ul":"CrossLinks_CrossLinks__ul__MDhiO"};